import { useCallback } from 'react';
import { useTranslation } from '../../i18n/LanguageContext';

/**
 * Texts of Merkez Yönetimi (`centers.*`). Stored values stay Turkish
 * ('Aktif' / 'İnaktif'); `statusLabel` only labels them. Excel stays Turkish.
 */
const useCenterText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`centers.${key}`, vars), [t]);
  const statusLabel = useCallback((value) => {
    if (value === 'Aktif') return t('centers.status.active');
    if (value === 'İnaktif') return t('centers.status.inactive');
    return value || '';
  }, [t]);
  /**
   * Splits a translated sentence around the given values so they can be shown
   * in bold wherever the language puts them: [{ text, bold }].
   */
  const richText = useCallback((key, boldVars) => {
    const names = Object.keys(boldVars);
    const vars = Object.fromEntries(names.map((name, index) => [name, `\u0007${index}\u0007`]));
    return t(`centers.${key}`, vars)
      .split('\u0007')
      .map((part, index) => (index % 2 === 1
        ? { text: String(boldVars[names[Number(part)]] ?? ''), bold: true }
        : { text: part, bold: false }))
      .filter((segment) => segment.text);
  }, [t]);
  return { t, language, locale, label, statusLabel, richText };
};

export default useCenterText;
